// Base questions numbering (common to all study types)
const baseQuestionNumbering = {
  qStudyPhase: "1",
  qStudyPhaseNames: "1a",
  qParticipantsName: "2",
  qComparative: "3",
};

// Dose Finding study questions numbering
export const questionNumberingForDoseFinding = {
  ...baseQuestionNumbering,
  // Study Design page
  qDoseFinding: "4",
  qDoseFindingSafety: "4a",
  qTgNamesDoseFinding: "4a1",
  qTgNames: "4a1",
  qParticipantNumber: "5",
  qDemPopulation: "6",
  qCutOffsForDemographicsTables: "7",
  // Efficacy Analysis page
  qIsEfficacy: "8",
  qEfficacyAnalytes: "8a",
  qPrimaryEfficacyComparisonNames: "8b",
  qEfficacyPopulations: "8c",
  qEfficacyAnalysisTypeNames: "8d",
  qEfficacyTimepointNames: "8e",
  qPrimaryEfficacy: "8f",
  qPrimaryEfficacyAnalytes: "8f1",
  qPrimaryEfficacyPopulation: "8f2",
  qPrimaryEfficacyAnalysisTypeNames: "8f3",
  qPrimaryEfficacyAnalytesComparison: "8f4",
  qPrimaryEfficacyTimepointNames: "8f5",
  qEfficacyKaplanMeierAnalytes: "9",
  // Safety Analysis page
  qSafetyBaseline: "10",
  qSafetyEndpoint: "11",
  qCutOffsForAbnormalLabTables: "12",
  qCutOffs: "13",
  qCutOffsForAdverseEventsTables: "14",
  // Bioavailability page
  qPkRelBio: "15",
  qPkRelBioTable: "15a",
  qPkRelBioComparisonPair: "15b",
  qPkRelBioTimelines: "15c",
  qPkRelBioEstimateRange: "15d",
};

// Single Arm study questions numbering
export const questionNumberingForSingleArm = {
  ...baseQuestionNumbering,
  // Study Design page
  qDemPopulation: "4",
  qCutOffsForDemographicsTables: "5",
  // Efficacy Analysis page
  qIsEfficacy: "6",
  qEfficacyAnalytes: "6a",
  qEfficacyPopulations: "6b",
  qEfficacyAnalysisTypeNames: "6c",
  qEfficacyTimepointNames: "6d",
  qPrimaryEfficacy: "6e",
  qPrimaryEfficacyAnalytes: "6e1",
  qPrimaryEfficacyPopulation: "6e2",
  qPrimaryEfficacyAnalysisTypeNames: "6e3",
  qPrimaryEfficacyAnalytesComparison: "6e4",
  qPrimaryEfficacyTimepointNames: "6e5",
  qEfficacyKaplanMeierAnalytes: "7",
  qSingleArmMultipleColumns: "8",
  // Safety Analysis page
  qSafetyBaseline: "9",
  qSafetyEndpoint: "10",
  qCutOffsForAbnormalLabTables: "11",
  qCutOffs: "12",
  qCutOffsForAdverseEventsTables: "13",
  // Bioavailability page
  qPkRelBio: "14",
  qPkRelBioTable: "14a",
  qPkRelBioComparisonPair: "14b",
  qPkRelBioTimelines: "14c",
  qPkRelBioEstimateRange: "14d",
};

// Multiple Arm study questions numbering
export const questionNumberingForMultipleArm = {
  ...baseQuestionNumbering,
  // Study Design page
  qDoseFinding: "4",
  qTgNames: "4a",
  qTgNamesComparison: "4b",
  qParticipantNumber: "5",
  qDemPopulation: "6",
  qCutOffsForDemographicsTables: "7",
  // Efficacy Analysis page
  qIsEfficacy: "8",
  qEfficacyAnalytes: "8a",
  qPrimaryEfficacyComparisonNames: "8b",
  qEfficacyPopulations: "8c",
  qEfficacyAnalysisTypeNames: "8d",
  qEfficacyTimepointNames: "8e",
  qPrimaryEfficacy: "8f",
  qPrimaryEfficacyAnalytes: "8f1",
  qPrimaryEfficacyPopulation: "8f2",
  qPrimaryEfficacyAnalysisTypeNames: "8f3",
  qPrimaryEfficacyAnalytesComparison: "8f4",
  qPrimaryEfficacyTimepointNames: "8f5",
  qEfficacyKaplanMeierAnalytes: "9",
  // Safety Analysis page
  qSafetyBaseline: "10",
  qSafetyEndpoint: "11",
  qCutOffsForAbnormalLabTables: "12",
  qCutOffs: "13",
  qCutOffsForAdverseEventsTables: "14",
  // Bioavailability page
  qPkRelBio: "15",
  qPkRelBioTable: "15a",
  qPkRelBioComparisonPair: "15b",
  qPkRelBioTimelines: "15c",
  qPkRelBioEstimateRange: "15d",
};
